import {Box, Divider, Grid, Stack} from "@mui/material";

import {useBreakpointContext} from "@nitra/nkmb-card-components";
import {
	NkmbIconDolzina,
	NkmbIconFaul,
	NkmbIconGol,
	NkmbIconGradnja,
	NkmbIconKapaciteta,
	NkmbIconLokacija,
	NkmbIconLv,
	NkmbIconReflektorji
} from "@nitra/nkmb-theme";
import {CardContainerTitle} from "components/CardContainerTitle";
import {InnerWidthContainer} from "components/widthControlElements";
import React from "react";
import {useTranslation} from "react-i18next";
import {ClubStadiumTabNavigatorButtons} from "views/club/stadium/ClubStadiumTabNavigatorButtons";
import {ClubBanner} from "../../ClubBanner";
import {ClubStadiumInfoEmblem} from "./ClubStadiumInfoEmblem";
import {StadiumEntrances} from "./StadiumEntrances";
import {StadiumPrePurchaseTickets} from "./StadiumPrePurchaseTickets";
import {StadiumSchema} from "./StadiumSchema";
import {StadiumTicketBuySpots} from "./StadiumTicketBuySpots";

export function ClubStadiumInfo() {
	const breakpoint = useBreakpointContext()
	const {t} = useTranslation()

	const [isMobile, setIsMobile] = React.useState(false)

	React.useEffect(() => {
		setIsMobile(breakpoint === "xs" || breakpoint === "sm")
	}, [breakpoint])

	return (
		<Stack>
			<ClubBanner
				url={"/images/club/banners/stadium-info.png"}
				mainText={t("club.stadium.name")}
				subText={t("club.stadium.subtitle")}
			/>
			<ClubStadiumTabNavigatorButtons/>
			<InnerWidthContainer>
				<Stack sx={{width: "100%", pt: isMobile ? 2 : 0}}>
					<CardContainerTitle title={t("club.stadium.basicInfo")}/>
					<Grid container spacing={2} justifyContent={"space-between"}>
						<ClubStadiumInfoEmblem
							emblem={NkmbIconLv}
							upperText={t("club.stadium.heartOfMyCity")}
							mainText={t("club.stadium.name")}
							lowerText={t("club.stadium.shortName")}
						/>
						<ClubStadiumInfoEmblem emblem={NkmbIconLokacija} upperText={t("club.stadium.address")}
						                       mainText={t("club.stadium.addressLine1")}
						                       lowerText={t("club.stadium.addressLine2")}/>
						<ClubStadiumInfoEmblem emblem={NkmbIconKapaciteta} upperText={t("club.stadium.capacity")}
						                       mainText={t("club.stadium.capacityValue")}
						                       lowerText={t("club.stadium.seats")}/>
						<ClubStadiumInfoEmblem emblem={NkmbIconDolzina} upperText={t("club.stadium.fieldDimensions")}
						                       mainText={t("club.stadium.fieldDimensionsValue")}
						                       lowerText={t("club.stadium.meters")}/>
						<ClubStadiumInfoEmblem emblem={NkmbIconFaul} upperText={t("club.stadium.firstMatch")}
						                       mainText={t("club.stadium.firstMatchDate")}
						                       lowerText={t("club.stadium.firstMatchTeams")}/>
						<ClubStadiumInfoEmblem emblem={NkmbIconGol} upperText={t("club.stadium.firstGoal")}
						                       mainText={t("club.stadium.firstGoalScorer")}
						                       lowerText={t("club.stadium.firstGoalDate")}/>
						<ClubStadiumInfoEmblem emblem={NkmbIconGradnja} upperText={t("club.stadium.built")}
						                       mainText={t("club.stadium.builtYear")}
						                       lowerText={t("club.stadium.renovated")}/>
						<ClubStadiumInfoEmblem emblem={NkmbIconReflektorji} upperText={t("club.stadium.floodlights")}
						                       mainText={t("club.stadium.floodlightsValue")}
						                       lowerText={t("club.stadium.lux")}
						                       isLast={true}
						/>
					</Grid>
					<CardContainerTitle sx={isMobile ? {pt: 8} : {}} title={t("club.stadium.schemaTitle")}/>
					<Grid container sx={{width: "100%"}} spacing={2}>
						<Grid item xs={12} md={6}>
							<StadiumSchema/>
						</Grid>
						<Grid item xs={12} md={6} lg={3} sx={isMobile ? {mt: 9} : {}}>
							<StadiumTicketBuySpots/>
							{isMobile && <Box sx={{py: 2}}><Divider/></Box>}
							{!isMobile && <StadiumPrePurchaseTickets/>}
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<StadiumEntrances/>
							{isMobile && <Box sx={{py: 2}}><Divider/></Box>}
							{isMobile && <StadiumPrePurchaseTickets/>}
						</Grid>
					</Grid>
				</Stack>
			</InnerWidthContainer>
		</Stack>
	)
}
